<template>
    <div class="simulado" @click="irParaSimulado">
        <div class="card-image">
            <a class="btn-fav" :class="{ active: isFavorited }" @click="toggleFavorite" title="Adicionar aos favoritos">
                <i :class="isFavorited ? 'fa-solid fa-heart' : 'fa-regular fa-heart'"></i>
            </a>
            <a class="btn-cart" @click="addToCart" title="Adicionar ao carrinho">
                <i class="fa fa-cart-plus icon"></i>
            </a>
            <img class="img-default" src="../assets/background/capa-padrao-simulado.png" />
            <img class="img-hover" src="../assets/background/capa-hover-simulado.png" />
            <div class="hover-overlay">
                <p class="price-discipline">R$ {{ displayPrice }}</p>
            </div>
        </div>

        <div class="simulado-info">
            <span class="title-simulado">Simulado {{ numero }}</span>
        </div>
        <div class="hover-purple"></div>
    </div>
</template>

<style scoped src="../styles/CardSimulated.css" />

<script>
import { getPriceByType, formatPrice } from '@/utils/pricing';

export default {
    name: 'CardSimulated',
    props: {
        simulado: {
            type: Object,
            required: true
        },
        numero: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isFavorited: false,
        };
    },
    computed: {
        displayPrice() {
            return formatPrice(getPriceByType('atividade'));
        }
    },
    methods: {
        toggleFavorite(event) {
            event.stopPropagation();
            this.isFavorited = !this.isFavorited;
        },
        addToCart(event) {
            event.stopPropagation();
            const item = {
                codigo_disciplina: this.simulado.codigo_aula,
                nome_disciplina: `Simulado ${this.numero}`,
                url_imagem: null,
                preco: getPriceByType('atividade'),
                tipo: 'atividade'
            };
            this.$emit("add-to-cart", item);
        },
        irParaSimulado() {
            this.$router.push({
                path: '/Simulated',
                query: {
                    codigo_aula: this.simulado.codigo_aula
                }
            });
        }
    }
};
</script>
